import React from 'react'
import { Avatar, Box, Button, Card, CardActions, CardContent, CardMedia, Container, Grid, Paper, Stack, styled, Typography, useMediaQuery } from '@mui/material'
import { Facebook, Instagram, Mail, Phone, WhatsApp } from '@mui/icons-material';
import zillow from '../assests/rev-zillow.png'
import banner22 from '../assests/living1.jpg';

const iconsArray = [
    {
        icon: <Phone />,
        title: 'Book your free Listing Consultation',

    },
    {
        icon: <WhatsApp />,
        title: 'Photoshoot',
    },
    {
        icon: <Instagram />,
        title: 'On the Market',
    },
    {
        icon: <Facebook />,
        title: 'Negotiate a Deal',
    },
    {
        icon: <Mail />,
        title: 'We Handle the Paperwork',
    },
];

const StyledBtn = styled(Button)(({ theme, matches }) => ({
    display: 'inline-block',
    textAlign: 'center',
    color: '#fff',
    background: '#978A7D',
    borderRadius: '80px',
    fontSize: '14.5px',
    padding: '0px 25px',
    fontWeight: 700,
    transition: '0.15s',
    width: '100%',
    maxWidth: '220px',
    minWidth: '190px',
    height: '40px',
    marginBottom: '0px',
    marginRight: 'auto',
    marginTop: '0em',
    textTransform: "none",
    '&:hover': {
        background: '#444444',
        color: '#fff',
        border: '1px solid #444444'
    }
}))


const Contactus = () => {
    const matches = useMediaQuery('(max-width:600px)');
    return (
        <Paper elevation={0} sx={{ borderRadius: 'none' }}>
            <Container maxWidth="xl">
                <Card sx={{ display: 'flex', flexDirection: matches ? 'column' : 'row',justifyContent: 'center', alignItems: 'center', borderRadius: '10px', background: '#EFE8E5', m: matches? '7em 0 3em 0': '9em 7em 7em 7em' }} elevation={0}>
                    <CardMedia
                        component="img"
                        sx={{ height:matches ? 450 : 700, width: '100%' }}
                        image={`${banner22}`}
                        title="green iguana"
                    />
                    <Box maxWidth="lg" sx={{ display: 'flex', flexDirection: matches ? 'column' : 'column', width: '100%', justifyContent: matches ? 'center' :'start', alignItems: matches ? 'center' :'start', p: matches? '1em 0': '0em 5em' }}>
                        <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: matches ? 'center' : 'start', alignItems: matches ? 'center' : 'start', }}>

                            <Typography variant="h4" gutterBottom sx={{ textAlign: matches ? 'center' : 'start', }}>
                                Real Prop
                            </Typography>
                            <Typography variant={matches ? 'h7' :"h6"} color="text.secondary" gutterBottom sx={{ textAlign: matches ? 'center' : 'start', }}>
                                Selling a home in today's market can be challenging, but we make the entire process easy and stress-free.

                                Our in depth marketing strategies make sure your home is seen by as many potential buyers as possible, which results in a quicker sale while maximizing profits.

                            </Typography>
                        </CardContent>
                        <CardActions sx={{ display: 'flex', flexDirection:  matches ? 'column' : 'row', justifyContent:  matches ? 'center' : 'start', alignItems:  matches ? 'center' : 'start', }}>
                            <StyledBtn matches={matches}>
                                Contact us
                            </StyledBtn>
                        </CardActions>
                    </Box>
                </Card>
            </Container>
        </Paper>
    )
}

export default Contactus